module.exports = __webpack_public_path__ + "static/media/hackathon-flyer.ccb65787.png";